<div class="main-content">
  <app-header [title]="'HEADER.TITLE_TICKET' | translate" [subtitle]="'HEADER.SUBTITLE_TICKET' | translate" />

  <div class="row mt-5">
    <div class="col-12">
      <app-icam-container *appHasRole="['CUSTOMER', 'CUSTOMER_PARTNER', 'ADMIN']">
        <div class="banner d-flex flex-column flex-md-row" [ngClass]="isLight ? 'light' : 'dark'">
          <div class="d-flex align-items-center">
            <div class="icon-circle me-3">
              <app-icam-icon [iconName]="'headset'" iconColor="green" [iconHeight]="'15px'" [isDefault]="true" />
            </div>
            <div class="text-container">
              <h2 class="my-0 py-0">
                <span class="text-container-bold">{{ 'BANNER.NEED_ASSISTANCE' | translate }} </span>
                <span class="fw-normal">{{ 'BANNER.ASK_INFORMATION' | translate }}</span>
              </h2>
            </div>
          </div>
          <div class="button-container mt-3 mt-md-0">
            <button class="ticket-button" [routerLink]="['/ticket', 'new']">
              {{ 'BANNER.NEW_TICKET' | translate }}
            </button>
          </div>
        </div>
      </app-icam-container>
    </div>
  </div>
  <div class="row mt-5">
    <div class="col-12">
      @if (lastTicket) {
        <app-icam-container [iconName]="'bell'" [iconColor]="'white'" [isClosable]="true" [fixedTheme]="'dark'">
          <app-icam-ticket [ticket]="lastTicket" />
        </app-icam-container>
      }
    </div>
  </div>
  <div class="row mt-5">
    <div class="col-12">
      <app-icam-container [iconName]="'ticket'" [iconColor]="'white'" class="my-5">
        <div class="pb-2">
          <app-table
            [allValues$]="openedTickets$"
            [type]="'open_tickets'"
            [hasChart]="false"
            (selectedPage)="onOpenedTicketPage($event)"
            [prevPage]="openedPrevPage"
            [currentPage]="openedCurrentPage"
            [nextPage]="openedNextPage"
            [totalPages]="openedTotalPages"
            [useInlineKeywordFilter]="true"
          />
        </div>
        <div class="pt-2">
          <app-table
            [allValues$]="closedTickets$"
            [type]="'closed_tickets'"
            (selectedFilter)="onSelectedFilter($event)"
            [hasChart]="false"
            [filters$]="ticketFilter$"
            (selectedPage)="onClosedTicketPage($event)"
            [prevPage]="closedPrevPage"
            [currentPage]="closedCurrentPage"
            [nextPage]="closedNextPage"
            [totalPages]="closedTotalPages"
            [useInlineKeywordFilter]="true"
          />
        </div>
      </app-icam-container>
    </div>
  </div>
</div>
